import React from 'react';
import { cn } from '../../lib/utils';
import { useLang } from '../../lib/i18n';

interface BadgeProps { status: string; className?: string; }

const STATUS_STYLES: Record<string, string> = {
  green:          'bg-green-100 text-green-800',
  red:            'bg-red-100 text-red-800',
  expired:        'bg-gray-100 text-gray-600',
  pending:        'bg-yellow-100 text-yellow-800',
  out_of_credits: 'bg-orange-100 text-orange-800',
  approved:       'bg-green-100 text-green-800',
  denied:         'bg-red-100 text-red-800',
};

export function StatusBadge({ status, className }: BadgeProps) {
  const { t } = useLang();
  const key = status?.toLowerCase() as keyof typeof t.status;
  const style = STATUS_STYLES[key] ?? 'bg-gray-100 text-gray-600';
  const label = t.status[key] ?? status;
  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium', style, className)}>
      {label}
    </span>
  );
}
